import {
  fork,
  put,
  all,
  call,
  select,
  takeEvery,
  takeLatest,
  actionChannel
} from 'redux-saga/effects'
import history from 'startup/history'
import { delay, buffers } from 'redux-saga'
import { get } from 'axios'
import {
  error
} from 'containers/App/Notification/actions'
import {
  withAuthorization,
  post
} from 'helpers/RequestUtil'

import {
  updateEntities,
  updateTables,
  removeTables
} from 'containers/Entity/actions'
import {
  entitySelector
} from 'containers/Entity/selectors'
import {
  APPLY_CHANGES,
  SUBMIT_CHANGES,
  ON_HEADER_CLICK,
  ON_APPLY_FILTER,
  ON_MENU_HIDE,
  ON_INPUT_HEADER_VALUE_CHANGE,
  ON_COLUMN_REORDER,
  ON_HEADER_FILTER_CHANGE,
  ON_SORT_CHANGE,
  ON_INPUT_CHANGE,
  ON_SUBMIT,
  ON_ROW_SIZE_CHANGE,
  UPDATE_ROW_SIZE,
  defaultSupportTeamFilters,
  defaultSearchFilters,
  ON_SECTION_RENDER,
  CANCEL_CHANGES,
  CLEAR_CHANGES,
  REMOVE_HEADER_FILTER,
  SELECT_CUSTOM_VIEW,
  RESET_HEADER_FILTERS,
  FILTER_CHANGE
} from './constants'

import {
  updateChangedProjects,
  updateCurrentIndex,
  updateInputHeaderList,
  updateMenuActive,
  onHeaderFilterChange,
  onSortChange,
  updateListOrder,
  updateSortIndex,
  updateSortType,
  updateCustomColOrder,
  updateHeaderFilter,
  updateSortBy,
  updateInput,
  updateRowSize,
  updateMaxRowSize,
  updateMyProjectsList,
  clearSelectedProjects,
  onTogglePopup,
  updatePopupPage,
  startPostProjectChanges,
  postProjectChangesSuccess,
  postProjectChangesError,
  finishLoading,
  cancelChangesPopup,
  updateErrors,
  updateAllHeaderFilters,
  onSelectCustomView,
  showChangedProjects,
  filterChange
} from './actions'

import {
  currentFormChangesStateSelector,
  selectedProjectsFullInfoSelector,
  changedProjectsStateSelector,
  menuActiveStateSelector,
  currentSortType,
  sortIndexStateSelector,
  headersSelector,
  unformattedHeadersSelector,
  listOrderStateSelector,
  sortByStateSelector,
  sortTypeStateSelector,
  queryFieldFiltersSelector,
  customColOrderStateSelector,
  fromStateSelector,
  rowSizeValueSelector,
  inputValueSelector,
  myProjectsListStateSelector,
  getActiveCustomViewSelector
} from './selectors'

import { baseURL } from 'config'
import P from 'helpers/predicates'
import * as R from 'ramda'

import { nameSelector } from 'containers/User/Login/selectors'
import { allDefaultViewSelectors } from '../Project/ElasticSearch/selectors'


const buildQuery = R.compose(
  R.join('&'),
  R.map(([key, value]) => `${key}=${value}`),
  R.filter(R.propSatisfies(P.isNotEmptyOrNil, '1')),
  R.toPairs
)

function* clearProjectList() {
  yield put(removeTables('projects'))
}
function* fetchProjectList(urlParams) {
  try {
    const { data } = yield call(
      withAuthorization(get),
      `${baseURL}/api/search/myProjects?${urlParams}`
    )
    return data
  } catch (err) {
    yield console.log('Failed to get projects.')
  }
}

function* fetchProjectFilters() {
  let filters = []
  try {
    const { data } = yield call(
      withAuthorization(get),
      `${baseURL}/api/search/schema`
    )
    const project_filters = P.reduceWithIndex(
      (acc, val, index) => R.assoc(index, { index, ...val }, acc),
      {}
    )(data)

    yield put(updateEntities({ project_filters }))
  } catch (err) {
    yield console.log(error('Failed to get project filters.'))
  }
  return filters
}

function* handleFetchAeSelections() {
  try {

    const { data } = yield call(
      get,
      '/api/fulcrum/ae_details_selection'
    )
    let obj = { ae_details_selection: data.data.attributes }
    yield put(updateEntities(obj))
  } catch (error) {
    yield console.log('error with getting ae_details')
  }
}

function* postProjectChanges(list) {
  try {
    yield put(startPostProjectChanges())
    const { data } = yield call(
      post,
      'project_list',
      list,
      'api/fulcrum/my_projects_views/update_projects',
      false
    )
    yield put(showChangedProjects(data.projectList))
    yield put(updateErrors(data.errorList))
    yield put(postProjectChangesSuccess())
  } catch (error) {
    console.log(error)
    yield put(postProjectChangesError(error))
    yield put(updatePopupPage('error'))
    yield put(updateErrors(error))
  }
}
function* setURLParams() {
  // input value/filter
  const query = yield select(inputValueSelector)
  // const scopes = yield select(queryFiltersSelector)

  // from 100 size 25? which values
  const from = yield select(fromStateSelector)
  const size = yield select(rowSizeValueSelector)

  // sortby asc or desc
  const sortBy = yield select(sortByStateSelector)

  // sortType - the field
  const sortType = yield select(sortTypeStateSelector)

  // header filters - ie the custom ones you select from the table header
  const filters = yield select(queryFieldFiltersSelector)

  // sortIndex - the index of the header previously selected
  const sortIndex = yield select(sortIndexStateSelector)

  // take these out since we are not filtering search filters
  const fields = defaultSearchFilters
  const name = yield select(nameSelector)

  const customColOrder = yield select(customColOrderStateSelector)
  const urlParams = buildQuery({
    query,
    from,
    size,
    sortBy,
    sortType,
    fields,
    username: name,
    filters: filters.join(',')
  })
  return urlParams
}

function* handleFetchProjectsList() {
  const urlParams = yield call(setURLParams)
  const data = yield call(
    fetchProjectList,
    urlParams
  )
  if (data) {
    const { hits: { total, hits } } = data
    if (total !== 0) {
      const projectIds = R.map(R.prop('_id'))(hits)
      const projects = R.reduce(
        (acc, { _id: id, _source: source }) =>
          R.assoc(id, { _id: id, id, ...source }, acc)
        ,
        {}
      )(hits)
      let normalized = {
        result: { projects: projectIds },
        entities: { projects }
      }
      yield put(updateMaxRowSize(total))
      yield put(updateMyProjectsList(projects))
      yield put(updateTables(normalized))
    }
  }
}



function* handleOnSubmit() {
  yield call(clearProjectList)
  yield call(handleFetchProjectsList)
}

function* handleOnApplyFilter({ columnIndex, filter, sort }) {
  yield put(onHeaderFilterChange(columnIndex, filter))
  yield put(onSortChange(columnIndex, sort))
  yield put(updateMenuActive(false))
  yield fork(handleOnSubmit)
}

function* handleOnMenuHide() {
  yield put(updateMenuActive(false))
}


function* updateColumnOrdering(newColsList) {
  let listOrdering = JSON.parse(JSON.stringify(yield select(listOrderStateSelector)))
  const newColsIndices = R.map(colName => listOrdering[colName])(newColsList).sort((a, b) => a - b)
  newColsList.forEach((col, index) => {
    listOrdering[col] = newColsIndices[index]
  })
  yield put(updateListOrder(listOrdering))
}

function* makeChangesToProjects(changes, selectedProjects) {
  const { formDetails, formType } = changes
  // if the user types in all caps DELETE the data point will be blank. otherwise it is ignored if its a blank string

  let parsedDetails = {}
  yield Object.entries(formDetails).forEach((entry) => {
    if (entry[1] !== '') {
      if (entry[1] === 'DELETE') {
        parsedDetails[entry[0]] = ''
      } else {
        parsedDetails[entry[0]] = entry[1]
      }
    }
  })

  // deep copy the selected projects to see if
  let list = JSON.parse(JSON.stringify(selectedProjects))
  // get changed projects
  let changedList = yield select(changedProjectsStateSelector)
  changedList = JSON.parse(JSON.stringify(changedList))

  let modifiedProjects = yield list.map((project) => {
    // parse selected projects and see if they already exist in changedProjects
    let current = changedList.find((changed) => {
      return changed.id === project.id
    })
    if (current === undefined || current === null) {
      current = project
    } else {
      changedList = R.reject((changed) => changed.project_id === project.project_id, changedList)
    }
    // console.log(current, changedList)

    if (!current.hasOwnProperty('modified')) {
      current['modified'] = []
    }

    if (formType === 'schedule') {
      Object.entries(parsedDetails.schedule).forEach((field) => {
        let key = field[0]
        if (field[1].date.includes('/')) {
          const [month, day, year] = field[1].date.split('/')
          const newDate = [year, month, day].join('-')
          current['schedule'][key] = newDate
          current['modified'].push('schedule')
        } else {
          current['schedule'][key] = field[1].date
          current['modified'].push('schedule')
        }
      })
    } else if (formType === 'weeklyUpdates') {
      let obj = {
        date: `Week: ${parsedDetails.week}, Year: ${parsedDetails.year}`,
        message: parsedDetails.weekly_update_text,
        role: parsedDetails.weekly_update_role,
        username: parsedDetails.username
      }
      current['last_weekly_update'] = obj
      current['modified'].push('last_weekly_update')
    } else {
      for (const key in parsedDetails) {
        current[key] = parsedDetails[key]
        current['modified'].push(key)
      }
    }
    return current
  })
  // console.log(changedList)
  return modifiedProjects.concat(changedList)
}

function* handleOnColumnReorder({ columnsMoved, targetIndex }) {
  let currSortIndex = yield select(sortIndexStateSelector)
  const headers = yield select(headersSelector)
  const type = R.path([currSortIndex, 'type'])(headers)

  // update column ordering in redux store
  let colsList = yield select(unformattedHeadersSelector)
  targetIndex = (columnsMoved[0] < targetIndex) ? targetIndex - columnsMoved.length : targetIndex
  const moveArrayItemsToNewIndex = (arr, oldIndex, numItems, newIndex) => {
    let itemsToMove = arr.splice(oldIndex, numItems)
    arr.splice(newIndex, 0, ...itemsToMove)
    return arr
  }
  moveArrayItemsToNewIndex(colsList, columnsMoved[0], columnsMoved.length, targetIndex)
  yield call(updateColumnOrdering, colsList)

  // update sort index if reordered columns include currently sorted column
  currSortIndex = colsList.indexOf(type)
  yield put(updateSortIndex(currSortIndex))
  yield put(updateSortType(type))

  // update URL to reflect column reordering
  yield put(updateCustomColOrder(true))
  yield call(setURLParams)
}

function* findProjectsAndUpdate(projects) {
  let current = yield select(myProjectsListStateSelector)
  let list = JSON.parse(JSON.stringify(current))
  projects.forEach((project) => {
    project.id = parseInt(project._id)
    list[project._id] = project
  })
  yield put(updateMyProjectsList(list))
}

function* handleOnInputHeaderValueChange({ value }) {
  // yield console.log('input header value source thing')
  yield delay(500)
  const from = yield select(fromStateSelector)
  const size = yield select(rowSizeValueSelector)
  const query = yield select(inputValueSelector)
  // const scopes = yield select(queryFiltersSelector)
  const filters = yield select(queryFieldFiltersSelector)
  const sortType = yield select(currentSortType)
  const sortBy = yield select(sortByStateSelector)
  const name = yield select(nameSelector)
  const urlParams = buildQuery({
    query,
    from,
    size,
    sortBy,
    sortType,
    username: name,
    filters: filters.join(','),
    aggregate: `${sortType}:${value}`
  })
  const data = yield call(
    fetchProjectList,
    urlParams
  )
  // if aggregations have nested than remove by_nested key
  const field = R.lensPath(['aggregations', sortType])
  const buckets = R.lensPath(['aggregations', sortType, 'buckets'])
  const key = R.lensProp('key')
  const list = R.compose(
    R.view(buckets),
    R.over(buckets, R.map(R.ifElse(
      R.is(String),
      R.identity,
      R.toString
    ))),
    R.over(buckets, R.map(R.view(key))),
    R.over(field, R.ifElse(
      R.has('by_nested'),
      R.path(['by_nested']),
      R.identity
    ))
  )(data)
  yield put(updateInputHeaderList(list))
  yield put(clearSelectedProjects())
}


function* handleApplyChanges() {
  // save the type of form changes we want
  // find the projects that are selected
  // apply the form changes we want to the selected projects
  // save to the frontend and change the color of the thing we changed
  // push the button to submit to the backend

  const changes = yield select(currentFormChangesStateSelector)
  const selectedProjects = yield select(selectedProjectsFullInfoSelector)
  const modifiedProjects = yield call(makeChangesToProjects, changes, selectedProjects)
  console.log(modifiedProjects)
  yield put(updateChangedProjects(modifiedProjects))
  yield call(findProjectsAndUpdate, modifiedProjects)
  yield put(clearSelectedProjects())
}

function* handleOnHeaderClick({ columnIndex }) {
  const active = yield select(menuActiveStateSelector)
  yield put(updateCurrentIndex(columnIndex))
  yield put(updateInputHeaderList([]))
  yield put(updateMenuActive(true))
}

function* handleSubmitChanges() {
  yield put(updatePopupPage('submit'))
  yield put(onTogglePopup())

  // start postprojectchanges
  const changedList = yield select(changedProjectsStateSelector)
  yield call(postProjectChanges, changedList)
  // show loading circle

  // yield put(cancelChangesPopup())
  // receive updated results
  // update state


}

function* handleOnSortChange({ columnIndex, value }) {
  if (value) {
    const headers = yield select(headersSelector)
    const type = R.path([columnIndex, 'type'])(headers)
    yield put(updateSortIndex(columnIndex))
    yield put(updateSortType(type))
    yield put(updateSortBy(value))
  }
}

function* handleOnHeaderFilterChange({ columnIndex, filter }) {
  const headers = yield select(headersSelector)
  yield put(updateHeaderFilter(headers[columnIndex].type, filter))
}

function* handleInputChange({ value }) {
  yield put(updateInput(value))
}

function* watchFetchForms() {
  yield call(handleFetchAeSelections)
}

function* watchFetchProjects() {
  yield call(handleFetchProjectsList)
  yield call(fetchProjectFilters)
}

function* handleOnRowSizeChange({ size }) {
  yield put(updateRowSize(size))
  yield fork(handleOnSubmit)
}

function* handleCancelChanges() {
  yield put(updatePopupPage('cancel'))
  yield put(onTogglePopup())
}

function* handleClearChanges() {
  const projects = yield select(entitySelector)
  yield put(updateMyProjectsList(projects.projects))
  yield put(clearSelectedProjects())
  yield put(onTogglePopup())
}

function* handleRemoveFilter() {
  yield put(updateMenuActive(false))
  yield fork(handleOnSubmit)
}

function* handleSelectCustomView() {
  let customView = yield select(getActiveCustomViewSelector)

  // update query field filters
  if (customView) {
    const {
      rowSize,
      headerFilters
    } = customView

    let formattedHeaderFilters = JSON.parse(headerFilters)
    yield put(updateRowSize(rowSize))
    yield put(updateAllHeaderFilters(formattedHeaderFilters))
    yield fork(handleOnSubmit)
  }
}

function* handleResetFilters() {
  yield put(onSelectCustomView(''))
  yield fork(handleOnSubmit)
  yield put(clearSelectedProjects())
}

function* handleFilterChange() {
  yield fork(handleOnSubmit)
}

function* watchApplyChangesToProjects() {
  yield takeLatest(APPLY_CHANGES, handleApplyChanges)
}

function* watchCancelChanges() {
  yield takeLatest(CANCEL_CHANGES, handleCancelChanges)
}

function* watchSubmitChanges() {
  yield takeLatest(SUBMIT_CHANGES, handleSubmitChanges)
}

function* watchOnHeaderClick() {
  yield takeLatest(ON_HEADER_CLICK, handleOnHeaderClick)
}

function* watchOnApplyFilter() {
  yield takeEvery(ON_APPLY_FILTER, handleOnApplyFilter)
}

function* watchOnMenuHide() {
  yield takeEvery(ON_MENU_HIDE, handleOnMenuHide)
}

function* watchOnInputHeaderValueChange() {
  yield takeLatest(ON_INPUT_HEADER_VALUE_CHANGE, handleOnInputHeaderValueChange)
}

function* watchOnColumnReorder() {
  yield takeLatest(ON_COLUMN_REORDER, handleOnColumnReorder)
}

function* watchOnHeaderFilterChange() {
  yield takeEvery(ON_HEADER_FILTER_CHANGE, handleOnHeaderFilterChange)
}

function* watchOnSortChange() {
  yield takeEvery(ON_SORT_CHANGE, handleOnSortChange)
}

function* watchOnInputChange() {
  yield takeLatest(ON_INPUT_CHANGE, handleInputChange)
}

function* watchOnSubmit() {
  yield takeLatest(ON_SUBMIT, handleOnSubmit)
}

function* watchOnRowSizeChange() {
  yield takeLatest(ON_ROW_SIZE_CHANGE, handleOnRowSizeChange)
}

function* watchClearChanges() {
  yield takeLatest(CLEAR_CHANGES, handleClearChanges)
}

function* watchOnHeaderFilterDelete() {
  yield takeLatest(REMOVE_HEADER_FILTER, handleRemoveFilter)
}

function* watchOnSelectCustomView() {
  yield takeLatest(SELECT_CUSTOM_VIEW, handleSelectCustomView)
}

function* watchResetFilters() {
  yield takeLatest(RESET_HEADER_FILTERS, handleResetFilters)
}

function* watchFilterChange() {
  yield takeLatest(FILTER_CHANGE, handleFilterChange)
}

function* MyProjects() {
  yield all([
    fork(watchFetchProjects),
    fork(watchFetchForms),
    fork(watchApplyChangesToProjects),
    fork(watchSubmitChanges),
    fork(watchCancelChanges),
    fork(watchOnColumnReorder),
    fork(watchOnHeaderClick),
    fork(watchOnApplyFilter),
    fork(watchOnMenuHide),
    fork(watchOnInputHeaderValueChange),
    fork(watchOnHeaderFilterChange),
    fork(watchOnSortChange),
    fork(watchOnInputChange),
    fork(watchOnSubmit),
    fork(watchOnRowSizeChange),
    fork(watchClearChanges),
    fork(watchOnHeaderFilterDelete),
    fork(watchOnSelectCustomView),
    fork(watchResetFilters),
    fork(watchFilterChange)
  ])
}



export default MyProjects